export const CONVERTED_IMAGE_PREVIEW_EXTENSIONS = ["heic", "heif", "dng"] as const;
export const CONVERTED_IMAGE_PREVIEW_MIMES = [
  "image/heic",
  "image/heif",
  "image/dng",
  "image/x-adobe-dng",
] as const;

export const PREVIEW_MAX_EDGE_PX = 2048;

function fileExtension(filename: string): string {
  return filename.split(".").pop()?.trim().toLowerCase() ?? "";
}

function normalizedMime(contentType?: string | null): string {
  return String(contentType ?? "").split(";")[0].trim().toLowerCase();
}

/** True when browsers cannot reliably render this image in `<img>`. */
export function needsConvertedImagePreview(
  filename: string,
  contentType?: string | null,
): boolean {
  const ext = fileExtension(filename);
  const mime = normalizedMime(contentType);
  return (
    (CONVERTED_IMAGE_PREVIEW_EXTENSIONS as readonly string[]).includes(ext) ||
    (CONVERTED_IMAGE_PREVIEW_MIMES as readonly string[]).includes(mime)
  );
}

export function isDngImagePreview(filename: string, contentType?: string | null): boolean {
  const ext = fileExtension(filename);
  const mime = normalizedMime(contentType);
  return ext === "dng" || mime === "image/dng" || mime === "image/x-adobe-dng";
}
